import { COUNTRIES } from ':constants/countries';

export const mapRegionCodeToCountryCode = (regionCode: string) =>
    COUNTRIES.find((c) => c.code.toLowerCase() === regionCode.trim().toLowerCase())?.code;
